import { HTTP_METHODS } from '@app/configs/api';
import { SOLVENCY_DECLARATION_ENDPOINTS } from '@app/configs/api/solvencyDeclaration';
import { getSolvencyDeclarationLocale } from '@app/utils/getSolvencyDeclarationLocale';
import { baseApi } from './baseApi';
import { TAG_TYPES } from './tagTypes';
export const solvencyDeclarationApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        createSolvencyDeclaration: builder.mutation({
            query: () => ({
                url: SOLVENCY_DECLARATION_ENDPOINTS.solvencyDeclaration,
                method: HTTP_METHODS.POST,
            }),
            invalidatesTags: [TAG_TYPES.SOLVENCY_DECLARATION, TAG_TYPES.FUNCTIONALITIES],
        }),
        fetchCurrentSolvencyDeclaration: builder.query({
            query: () => ({
                url: SOLVENCY_DECLARATION_ENDPOINTS.current,
            }),
            providesTags: [TAG_TYPES.SOLVENCY_DECLARATION],
        }),
        fetchSolvencyDeclarationQuestionnaireForm: builder.query({
            query: () => ({
                url: SOLVENCY_DECLARATION_ENDPOINTS.questionnaire,
                params: { locale: getSolvencyDeclarationLocale() },
            }),
            transformResponse({ questionnaire }) {
                return questionnaire;
            },
            providesTags: [TAG_TYPES.SOLVENCY_DECLARATION],
        }),
        submitSolvencyDeclaration: builder.mutation({
            query: (data) => ({
                url: SOLVENCY_DECLARATION_ENDPOINTS.submit,
                method: HTTP_METHODS.PUT,
                body: {
                    locale: getSolvencyDeclarationLocale(),
                    questionnaire: data,
                },
            }),
            invalidatesTags: [TAG_TYPES.SOLVENCY_DECLARATION],
        }),
        resubmitSolvencyDeclaration: builder.mutation({
            query: () => ({
                url: SOLVENCY_DECLARATION_ENDPOINTS.resubmit,
                method: HTTP_METHODS.PUT,
            }),
            invalidatesTags: [TAG_TYPES.SOLVENCY_DECLARATION, TAG_TYPES.FUNCTIONALITIES],
        }),
    }),
    overrideExisting: false,
});
export const { useCreateSolvencyDeclarationMutation, useFetchCurrentSolvencyDeclarationQuery, useLazyFetchCurrentSolvencyDeclarationQuery, useFetchSolvencyDeclarationQuestionnaireFormQuery, useSubmitSolvencyDeclarationMutation, useResubmitSolvencyDeclarationMutation, } = solvencyDeclarationApi;
